module.exports = __webpack_public_path__ + "static/img/20.ba19425.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/eng/20.png
// module id = zCT5
// module chunks = 0